import React, { useMemo, useCallback } from 'react';
import { InfoOutlined } from '@mui/icons-material';
import NotificationsOffOutlinedIcon from '@mui/icons-material/NotificationsOffOutlined';
import measurementsIcon from '#component/icon/measurements';
import { getYoungestMetrics } from '#component/device/helper';
import {
  InfoContainer,
  MetricsWrapper,
  InfoText,
  ColoredSpan,
  IconContainer,
  StyledTooltip,
  StyledNotificationsActiveRoundedIcon,
  StyledAccessTimeIcon
} from './styles';
import { momentFormat } from '#helper';

const FOUR_HOURS = 1000 * 60 * 60 * 4;

function DeviceInfo(props) {
  const {
    lastTimestamp,
    device,
    account,
    loading,
    devicesWithExcursions,
    alertTooltip
  } = props;

  const itemsToRender = useMemo(
    () =>
      getYoungestMetrics(device?.lastMetric?.youngest, account, ['temperature', 'humidity', 'battery']),
    [device, account]
  );
  const timestamp = lastTimestamp ? `${momentFormat(lastTimestamp, account, 'dateTimePartial')}` : null;
  const isExcursion = useCallback((d, excursions, item) => {
    const excursionDev = excursions.find(devWtExc => devWtExc.uid === d.uid);
    return excursionDev?.excursions[0].id === item.identifier;
  }, []);

  const timestampAlert = new Date().getTime() - new Date(lastTimestamp).getTime() > FOUR_HOURS;
  let anyExcursion = false;

  return (
    <InfoContainer>
      <MetricsWrapper>
        {itemsToRender.length ?
          itemsToRender.map(item => {
            const excursion =
              device.projectAlertId && isExcursion(device, devicesWithExcursions, item);

            if (!anyExcursion && excursion) anyExcursion = excursion;

            return (
              <InfoText key={item.identifier}>
                <ColoredSpan isRed={excursion}>
                  {loading ? null : measurementsIcon(item.identifier, device, item.value)}
                  <span>
                    {item.value}
                    {item.unit}
                  </span>
                </ColoredSpan>
              </InfoText>
            );
          }) :
          (
            <InfoText style={{ width: 24, height: 24 }} />
          )}
      </MetricsWrapper>
      <IconContainer>
        <StyledTooltip placement="right" title={alertTooltip} gutterRight>
          { device.projectAlertId ?
            <StyledNotificationsActiveRoundedIcon isRed={anyExcursion} /> :
            <NotificationsOffOutlinedIcon />}
        </StyledTooltip>
        <StyledTooltip
          placement="right"
          title={
            <div>
              {device.title}
              <div>{timestampAlert ? `${timestamp} (more than 4 hours)` : timestamp}</div>
            </div>
          }
        >
          {timestampAlert ?
            <StyledAccessTimeIcon isRed /> :
            <InfoOutlined />}
        </StyledTooltip>
      </IconContainer>
    </InfoContainer>
  );
}

export default DeviceInfo;
